module.exports = __webpack_public_path__ + "static/media/SamL.318b73b0.jpg";